import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import "../../assets/lucky7/css/lucky7.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import io from "socket.io-client";
const base_url = process.env.REACT_APP_API_URL;

const numberData = [
  { name: "2", display: "2" },
  { name: "3", display: "3" },
  { name: "4", display: "4" },
  { name: "5", display: "5" },
  { name: "6", display: "6" },
  { name: "7", display: "7" },
  { name: "8", display: "8" },
  { name: "9", display: "9" },
  { name: "10", display: "10" },
  { name: "11", display: "11" },
  { name: "12", display: "12" },
];

const diceImages = [
  "/assets/lucky7/images/bg1.png",
  "/assets/lucky7/images/bg2.png",
  "/assets/lucky7/images/bg3.png",
  "/assets/lucky7/images/bg4.png",
  "/assets/lucky7/images/bg5.png",
  "/assets/lucky7/images/bg6.png",
];

const getDisplayByBet = (bet) => {
  const item = numberData.find((d) => d.name === bet);
  return item ? item.display : "?";
};

const getDiceDisplay = (num) => {
  return diceImages[num - 1] || null;
};

const Lucky7 = () => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [popupActive, setPopupActive] = useState(false);
  const [activeTab, setActiveTab] = useState("my");
  const [selected, setSelected] = useState(null);
  const [balance, setBalance] = useState(10);
  const [timmer, setTimmer] = useState(60);
  const limit = 100;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [page2, setPage2] = useState(1);
  const [totalPages2, setTotalPages2] = useState(1);
  const [userBetData, setUserBetData] = useState([]);
  const [wallet, setWallet] = useState(0);
  const [winAmount, setWinAmount] = useState(0);
  const [loseAmount, setLoseAmount] = useState(0);
  const [winStatus, setWinStatus] = useState(0);
  const [period, setPeriod] = useState("");
  const [resultStatus, setResultStatus] = useState(0);
  const [displayResults, setDisplayResults] = useState([null, null]); // Two dice
  const [isSpinning, setIsSpinning] = useState(false);
  const [gameHistory, setGameHistory] = useState([]);
  const [gameStatus, setGameStatus] = useState(false);
  const [myBetDetailsActive, setMyBetDetailsActive] = useState(null);
  const [showResultPopup, setShowResultPopup] = useState(false);
  const [betPlacedActive, setBetPlacedActive] = useState(false);
  const [showHowToPlay, setShowHowToPlay] = useState(false);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [countDown, setCountDown] = useState(false);
  const [betPlaceProgress, setBetPlaceProgress] = useState(false);

  const socketRef = useRef(null);

  // Socket setup
  useEffect(() => {
    if (!token) return;

    socketRef.current = io(base_url, {
      auth: { token },
    });

    socketRef.current.on("connect", () => {
      // console.log("Socket connected for lucky7 user");
      socketRef.current.emit("joinRoom", "user");
    });

    // Listen for new game creation (from cron)
    socketRef.current.on("newGame", (data) => {
      console.log("New game started:", data);
      setPeriod(data.gameId);
      setTimmer(60); // Reset timer
      setDisplayResults([null, null]); // Reset results
      setGameStatus(false); // Allow new bets
      getWithAuthLucky7GameData(); // Refresh other data
    });

    // Listen for new bet placed (real-time update for other users/admins)
    socketRef.current.on("newBetLucky7", (newBet) => {
      console.log("New bet placed:", newBet);
      toast.success(`New bet on ${newBet.bet} for ₹${newBet.betAmount}`); // Optional notification
      // Update local game bets if needed, or refresh
      getWithAuthLucky7GameData(); // Refresh to include new bet in totals/history
    });

    socketRef.current.on("gameUpdated", () => {
      getWithAuthLucky7GameData(); // Refresh on game processed
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []);

  const audioFiles = {
    bet: new Audio("/assets/lucky7/audio/bet.mp3"),
    spin: new Audio("/assets/lucky7/audio/spin2.mp3"),
    click: new Audio("/assets/lucky7/audio/click.mp3"),
    countdown1: new Audio("/assets/lucky7/audio/countdown1.mp3"),
  };

  useEffect(() => {
    Object.values(audioFiles).forEach((audio) => {
      audio.preload = "auto";
      audio.load();
      audio.onerror = () => console.error(`Failed to load audio: ${audio.src}`);
    });
  }, []);

  function playSound(audio) {
    if (soundEnabled) {
      try {
        audio.currentTime = 0;
        audio
          .play()
          .catch((error) =>
            console.error(`Error playing ${audio.src}:`, error),
          );
      } catch (error) {
        console.error(`Error playing ${audio.src}:`, error);
      }
    }
  }

  const stopSound = (audio) => {
    if (!audio) return;
    audio.pause();
    audio.currentTime = 0;
  };

  const intervalsRef = useRef([]);

  useEffect(() => {
    let interval = null;
    if (timmer > 0) {
      interval = setInterval(() => {
        setTimmer((prev) => prev - 1);
      }, 1000);
    } else if (timmer === 0) {
      clearInterval(interval);
      setTimmer(60);
      setGameStatus(true);
      setIsSpinning(true);
      setResultStatus(1);
      playSound(audioFiles.spin);
      const startTime = Date.now();
      intervalsRef.current = [];
      for (let i = 0; i < 2; i++) {
        const intId = setInterval(() => {
          const randomDie = Math.floor(Math.random() * 6) + 1;
          setDisplayResults((prev) => {
            const updated = [...prev];
            updated[i] = getDiceDisplay(randomDie);
            return updated;
          });
        }, 60);
        intervalsRef.current.push(intId);
      }
      setTimeout(() => {
        intervalsRef.current.forEach((id) => clearInterval(id));
        intervalsRef.current = [];
        setIsSpinning(false);
      }, 3000);
      resetGame();
    }

    if (timmer <= 15) {
      if (countDown === false) {
        playSound(audioFiles.countdown1);
        setCountDown(true);
      }
    } else {
      if (countDown === true) {
        setCountDown(false);
      }
    }

    if (timmer === 9) {
      stopSound(audioFiles.countdown1);
      playSound(audioFiles.countdown1);
    }

    if (timmer < 0) {
      setTimmer(60);
    }

    return () => clearInterval(interval);
  }, [timmer]);

  useEffect(() => {
    return () => {
      intervalsRef.current.forEach((id) => clearInterval(id));
      intervalsRef.current = [];
    };
  }, []);

  const getLucky7GameData = async () => {
    try {
      const response = await axios.get(`${base_url}/api/get/lucky7GameData`, {
        params: { page, limit },
        headers: { "Content-Type": "application/json" },
      });

      if (response.data?.success === true) {
        const resultDice = response.data.result
          ? response.data.result
              .split(", ")
              .map((numStr) => getDiceDisplay(parseInt(numStr.trim())))
          : Array(2).fill(null);
        setDisplayResults(resultDice);
        setResultStatus(response.data.result ? 1 : 0);
        setPeriod(response.data.gameId);
        setTimmer(response.data.timmer);
        setWallet(response.data.money);
        setWallet(response.data.money);
        setGameHistory(response.data.lucky7Data);
        setUserBetData(response.data.lucky7UserBetData);
        setTotalPages(response.data.totalPages);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const getWithAuthLucky7GameData = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/get/getWithAuthLucky7GameData`,
        {
          params: { page, limit, page2 },
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.data?.success === true) {
        setPeriod(response.data.gameId);
        const resultDice = response.data.result
          ? response.data.result
              .split(", ")
              .map((numStr) => getDiceDisplay(parseInt(numStr.trim())))
          : Array(2).fill(null);
        setDisplayResults(resultDice);
        setResultStatus(response.data.result ? 1 : 0);
        setTimmer(response.data.timmer);
        setWallet(response.data.money);
        setWinAmount(response.data.winAmount);
        setLoseAmount(response.data.loseAmount);
        setWinStatus(response.data.winStatus);
        setGameHistory(response.data.lucky7Data);
        setUserBetData(response.data.lucky7UserBetData);
        setTotalPages(response.data.totalPages);
        setTotalPages2(response.data.totalPages2);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getWithAuthLucky7GameData();
    getLucky7GameData();
  }, [page]);

  const total = Number(balance || 0);

  const handleBalanceSelect = (value) => {
    playSound(audioFiles.click);
    setBalance(value);
  };

  const placeBet = async () => {
    playSound(audioFiles.click);

    if (gameStatus === true) {
      toast.error("Game is processing, please wait for the next round!");
      return;
    }

    if (betPlaceProgress === true) return toast.error("Bet is processing");
    setBetPlaceProgress(true);

    try {
      const response = await axios.post(
        `${base_url}/api/place/lucky7Bet`,
        {
          game_id: period,
          bet: selected,
          amount: total,
          bet_type: "BOARD",
        },
        {
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.data?.success === true) {
        playSound(audioFiles.bet);
        toast.success(`Bet Placed on ${selected} for ₹${total}`);
        setBetPlacedActive(true);
        setPopupActive(false);
        getWithAuthLucky7GameData();
        setBetPlaceProgress(false);
      } else {
        toast.error(response.data?.message || "Failed to place bet");
        setBetPlaceProgress(false);
      }
    } catch (error) {
      console.error("Bet placement error:", error);
      toast.error(
        error.response?.data?.message ||
          "Failed to place bet, please try again",
      );
      setBetPlaceProgress(false);
    }
  };

  const resetGame = () => {
    setTimeout(() => {
      intervalsRef.current.forEach((id) => clearInterval(id));
      intervalsRef.current = [];
      setIsSpinning(false);
      getWithAuthLucky7GameData();
      getLucky7GameData();

      if (betPlacedActive === true) {
        setShowResultPopup(true);
        setTimeout(() => {
          setShowResultPopup(false);
          setWinAmount(0);
          setLoseAmount(0);
          setWinStatus(0);
        }, 3000);
        setBetPlacedActive(false);
      }
      setGameStatus(false);
    }, 3000);
  };

  const pendingBetMap = React.useMemo(() => {
    const map = {};
    userBetData.forEach((bet) => {
      if (bet.status === 0) {
        map[bet.bet] = (map[bet.bet] || 0) + Number(bet.betAmount || 0);
      }
    });
    return map;
  }, [userBetData]);

  return (
    <>
      <div
        className="lucky7-container"
        style={{
          overflow:
            popupActive === true || countDown === true ? "hidden" : "scroll",
        }}
      >
        {countDown && (
          <div className="count-down text-white">
            <div className="outer-circle">{timmer}</div>
          </div>
        )}

        <div className="header">
          <span
            className="title"
            onClick={() => {
              playSound(audioFiles.click);
              // navigate(-1);
            }}
          >
            <ArrowLeft /> Back
          </span>
          <div className="header-right">
            <span className="money">₹{parseFloat(wallet).toFixed(2)}</span>
          </div>
        </div>

        <div className="period_div">
          <div className="period_div_left">
            <span>Game ID :-</span>
            <span>{period}</span>
          </div>
          <div>
            <button
              className="how-to-play-btn"
              onClick={() => {
                playSound(audioFiles.click);
                setShowHowToPlay(true);
              }}
            >
              ℹ️ How to Play
            </button>
          </div>
          <div className="period_div_right">
            <span id="timmer">{timmer}s</span>
          </div>
        </div>

        <div className="history-section">
          <div className="history-icon-section pb-2">
            {gameHistory.slice(0, 30).map((item, index) => {
              let n1 = null;
              let n2 = null;

              if (item.result) {
                const parts = item.result.split(", ");
                n1 = parseInt(parts[0], 10);
                n2 = parseInt(parts[1], 10);
              }

              const diceIcon = (n) =>
                n === 1
                  ? "⚀"
                  : n === 2
                    ? "⚁"
                    : n === 3
                      ? "⚂"
                      : n === 4
                        ? "⚃"
                        : n === 5
                          ? "⚄"
                          : n === 6
                            ? "⚅"
                            : "❓";

              return (
                <div
                  key={index}
                  className={`history-icon-card ${index === 0 ? "latest" : ""}`}
                >
                  <div className="history-result-inline">
                    <span className="sum">{n1 && n2 ? n1 + n2 : "?"}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Top Stamps - Two Dice */}
        <div className="stamps-row">
          {[0, 1].map((_, index) => (
            <div
              key={index}
              className={
                resultStatus === 1 ? "stamp dice-stamp" : "stamp empty-stamp"
              }
            >
              <div className={`stamp-content ${isSpinning ? "spinning" : ""}`}>
                {displayResults[index] && (
                  <img src={displayResults[index]} alt={`Dice ${index + 1}`} />
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="lucky7-board">
          <div
            className="lucky7-card andar"
            onClick={() => {
              playSound(audioFiles.click);
              setSelected("ANDAR");
              setPopupActive(true);
            }}
          >
            <h3>ANDAAR</h3>
            <div className="nums">1 2 3 4 5 6</div>
            <div className="win">₹10 के बनाओ ₹20 💥</div>
            {pendingBetMap["ANDAR"] > 0 && (
              <div className="board-bet-amount">₹{pendingBetMap["ANDAR"]}</div>
            )}
          </div>

          <div
            className="lucky7-card lucky"
            onClick={() => {
              playSound(audioFiles.click);
              setSelected("LUCKY7");
              setPopupActive(true);
            }}
          >
            <div className="seven-glow">7</div>
            <div className="lucky-label">LUCKY 7</div>
            <div className="win">₹10 के बनाओ ₹30 💥</div>
            {pendingBetMap["LUCKY7"] > 0 && (
              <div className="board-bet-amount">₹{pendingBetMap["LUCKY7"]}</div>
            )}
          </div>

          <div
            className="lucky7-card bahar"
            onClick={() => {
              playSound(audioFiles.click);
              setSelected("BAHAR");
              setPopupActive(true);
            }}
          >
            <h3>BAHAAR</h3>
            <div className="nums">8 9 10 11 12</div>
            <div className="win">₹10 के बनाओ ₹20 💥</div>
            {pendingBetMap["BAHAR"] > 0 && (
              <div className="board-bet-amount">₹{pendingBetMap["BAHAR"]}</div>
            )}
          </div>
        </div>

        {/* Tabs */}
        <div className="lucky7-tabs">
          <button
            className={`tab ${activeTab === "my" ? "active" : ""}`}
            onClick={() => {
              playSound(audioFiles.click);
              setActiveTab("my");
            }}
          >
            My History
          </button>
          <button
            className={`tab ${activeTab === "game" ? "active" : ""}`}
            onClick={() => {
              playSound(audioFiles.click);
              setActiveTab("game");
            }}
          >
            Game History
          </button>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === "game" ? (
            <div className="history-table">
              <table>
                <thead>
                  <tr>
                    <th>Game ID</th>
                    <th>Result</th>
                  </tr>
                </thead>
                <tbody>
                  {gameHistory && gameHistory.length > 0 ? (
                    gameHistory.map((row, i) => {
                      let n1 = null;
                      let n2 = null;
                      let sum = null;
                      if (row.result) {
                        const parts = row.result.split(", ");
                        n1 = parseInt(parts[0].trim());
                        n2 = parseInt(parts[1].trim());
                        sum = n1 + n2;
                      }
                      return (
                        <tr key={i}>
                          <td>{row.game_id}</td>
                          <td>
                            <div className="gameHistoryResult">
                              <span>{sum || "?"}</span>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="4"
                        style={{ textAlign: "center", color: "#888" }}
                      >
                        No game history found!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="pagination">
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage((prev) => Math.max(prev - 1, 1));
                  }}
                  disabled={page === 1}
                >
                  <ArrowLeft />
                </button>
                <span>
                  Page {page} of {totalPages}
                </span>
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage((prev) => Math.min(prev + 1, totalPages));
                  }}
                  disabled={page === totalPages}
                >
                  <ArrowRight />
                </button>
              </div>
            </div>
          ) : (
            <div className="history-table">
              <table>
                <thead>
                  <tr>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  {userBetData.length > 0 ? (
                    userBetData.map((row, i) => {
                      let n1 = null;
                      let n2 = null;
                      let sum = null;
                      if (row.result) {
                        const parts = row.result.split(", ");
                        n1 = parseInt(parts[0].trim());
                        n2 = parseInt(parts[1].trim());
                        sum = n1 + n2;
                      }
                      return (
                        <tr key={i}>
                          <td
                            onClick={() => {
                              playSound(audioFiles.click);
                              setMyBetDetailsActive(
                                myBetDetailsActive === row.id ? null : row.id,
                              );
                            }}
                          >
                            {/* My Bets */}
                            <div className="myBetTr">
                              <div className="my_bet_left_side_div">
                                <div className="myBetNumber">
                                  {row.bet === "ANDAR"
                                    ? "A"
                                    : row.bet === "BAHAR"
                                      ? "B"
                                      : "7"}
                                </div>
                                <div>
                                  <h5>{row.game_id}</h5>
                                  <h5>
                                    {new Date(row.created_at).toLocaleString()}
                                  </h5>
                                </div>
                              </div>
                              <div className="my_bet_right_side_div">
                                <div
                                  className={
                                    row.status === 1
                                      ? "myBetStatusWin"
                                      : row.status === 2
                                        ? "myBetStatusLose"
                                        : "myBetStatusPending"
                                  }
                                >
                                  <h5>
                                    {row.status === 1
                                      ? "Win"
                                      : row.status === 2
                                        ? "Lose"
                                        : "Pending"}
                                  </h5>
                                </div>
                                <h5
                                  className={
                                    row.status === 1
                                      ? "greenColor"
                                      : row.status === 2
                                        ? "redColor"
                                        : "orangeColor"
                                  }
                                >
                                  {row.status === 1
                                    ? "+" + parseFloat(row.winAmount).toFixed(2)
                                    : "-" +
                                      parseFloat(row.betAmount).toFixed(2)}
                                </h5>
                              </div>
                            </div>

                            {/* Details Section */}
                            <div
                              className="myBetDetails"
                              style={{
                                display:
                                  myBetDetailsActive === row.id
                                    ? "block"
                                    : "none",
                              }}
                            >
                              <h5>Details</h5>

                              <div className="myBetDetailRow">
                                <p>Game ID</p>
                                <p>{row.game_id}</p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Bet Amount</p>
                                <p className="redColor">
                                  {parseFloat(row.betAmount).toFixed(2)}
                                </p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Bet On</p>
                                <p>{row.bet}</p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Result</p>
                                <p className="orangeColor">
                                  {row.result
                                    ? `${n1} + ${n2} = ${sum}`
                                    : "Pending"}
                                </p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Win/Lose</p>
                                <p
                                  className={
                                    row.status === 1
                                      ? "greenColor"
                                      : row.status === 2
                                        ? "redColor"
                                        : "orangeColor"
                                  }
                                >
                                  {row.status === 1
                                    ? "+" + parseFloat(row.winAmount).toFixed(2)
                                    : "-" +
                                      parseFloat(row.betAmount).toFixed(2)}
                                </p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Available Balance</p>
                                <p className="greenColor">
                                  {parseFloat(row.current_money).toFixed(2)}
                                </p>
                              </div>
                              <div className="myBetDetailRow">
                                <p>Time</p>
                                <p>
                                  {new Date(row.created_at).toLocaleString()}
                                </p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td>Bet not available!</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="pagination">
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage2((prev) => Math.max(prev - 1, 1));
                  }}
                  disabled={page2 === 1}
                >
                  <ArrowLeft />
                </button>
                <span>
                  Page {page2} of {totalPages2}
                </span>
                <button
                  onClick={() => {
                    playSound(audioFiles.click);
                    setPage2((prev) => Math.min(prev + 1, totalPages2));
                  }}
                  disabled={page2 === totalPages2}
                >
                  <ArrowRight />
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Popup Section */}
        {popupActive && (
          <div className="">
            <div className="lucky7-bet">
              <div className="popup">
                <div className="popup-header">
                  <h2>Place Bet</h2>
                  <div className="select-box">
                    <span>Selected</span>
                    <strong>
                      {selected === "ANDAR"
                        ? "ANDAAR (2–6)"
                        : selected === "LUCKY7"
                          ? "LUCKY 7"
                          : "BAHAAR (8–12)"}
                    </strong>
                  </div>
                </div>

                <div className="popup-body">
                  <div className="balance-section">
                    <label>Enter Amount</label>
                    <input
                      type="number"
                      min="1"
                      value={balance}
                      onChange={(e) => setBalance(e.target.value)}
                      className="bet-input"
                      placeholder="Enter amount"
                    />
                  </div>

                  <div className="balance-options">
                    {[10, 50, 100, 500, 1000].map((val) => (
                      <button
                        key={val}
                        className={Number(balance) === val ? "active" : ""}
                        onClick={() => setBalance(val)}
                      >
                        ₹{val}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="popup-footer">
                  <button
                    className="cancel"
                    onClick={() => {
                      playSound(audioFiles.click);
                      setPopupActive(false);
                    }}
                  >
                    Cancel
                  </button>
                  <button className="total" onClick={placeBet}>
                    Total amount ₹{total.toFixed(2)}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* 🎉 Win / Lose Popup */}
      {showResultPopup && (
        <div className="result-popup-overlay">
          <div
            className={`result-popup ${
              winStatus === 1
                ? "popup-win"
                : winStatus === 2
                  ? "popup-lose"
                  : "popup-pending"
            }`}
          >
            <div className="popup-emoji">
              {winStatus === 1 ? "🎉" : winStatus === 2 ? "😢" : "⏳"}
            </div>
            <h2>
              {winStatus === 1
                ? "You Win!"
                : winStatus === 2
                  ? "You Lose!"
                  : ""}
            </h2>
            <p style={{ color: "#fff" }}>
              {winStatus === 1
                ? `You earned ₹${winAmount.toFixed(2)}`
                : winStatus === 2
                  ? `You lost your bet`
                  : `Waiting for result...`}
            </p>
          </div>
        </div>
      )}

      {/* 🧭 How to Play Popup */}
      {showHowToPlay && (
        <div
          className="howto-overlay"
          onClick={() => {
            playSound(audioFiles.click);
            setShowHowToPlay(false);
          }}
        >
          <div className="howto-popup" onClick={(e) => e.stopPropagation()}>
            <h2>How to Play Lucky7 🎲</h2>
            <div className="howto-content">
              <h3>🎮 Quick Start</h3>
              <ol>
                <li>
                  <strong>Join the Game:</strong> Log in and open Lucky7.
                </li>
                <li>
                  <strong>Select a Side:</strong> Tap a side to bet on the dice
                  total.
                </li>
              </ol>
              <h3>💰 Customize Your Bet</h3>
              <ul>
                <li>
                  <b>Balance:</b> Choose ₹10, ₹50, ₹100, or ₹1,000.
                </li>
              </ul>
              <h3>⏱️ Watch the Round</h3>
              <p>
                Timer counts down. When 0, two dice roll, sum determines winner.
              </p>
              <h3>🏆 Check Results</h3>
              <p>View Game History & My History for past bets.</p>
            </div>

            <button
              className="close-howto"
              onClick={() => {
                playSound(audioFiles.click);
                setShowHowToPlay(false);
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Lucky7;
